var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircleSolid = function SvgPlusCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .375C5.578.375.375 5.578.375 12S5.578 23.625 12 23.625 23.625 18.422 23.625 12 18.422.375 12 .375m6.75 12.938c0 .309-.253.562-.562.562h-4.313v4.313c0 .309-.253.562-.562.562h-2.626a.564.564 0 0 1-.562-.562v-4.313H5.813a.564.564 0 0 1-.563-.562v-2.626c0-.309.253-.562.563-.562h4.312V5.813c0-.31.253-.563.563-.563h2.624c.31 0 .563.253.563.563v4.312h4.313c.309 0 .562.253.562.563z"
  })));
};
export default SvgPlusCircleSolid;